import { getCitationSourceData } from '~/utils/citation-messages';

/**
 * Single source of truth for the `source` object both Discover (CitationInfoLabel.vue) and
 * Authoring's vanilla-DOM tag (citation-dom.js) render. `unsubstantiated` only ever gets
 * overlaid with `true`, never `false` — matches Discover's own merge so both surfaces agree.
 * @param {{externalId?: string, unsubstantiated?: boolean, isPrimarySource?: boolean, docType?: string}} params
 * @returns {{name: string, logo: string|null, type: 'internal'|'external', unsubstantiated: boolean, isPrimarySource: boolean, docType: string}}
 */
// Vite resolves the Veeva logo import to a root-relative path — fine for Discover's host page, but
// Authoring's iframe resolves root-relative paths against its own base, 404ing the image.
const resolveAssetUrl = (path) => {
  if (!path) return path;
  try {
    return new URL(path, window.location.origin).href;
  } catch {
    return path;
  }
};

export const resolveCitationSourceInfo = ({
  externalId,
  unsubstantiated,
  isPrimarySource = false,
  docType = '',
} = {}) => {
  const base = getCitationSourceData(externalId);

  return {
    ...base,
    logo: resolveAssetUrl(base.logo),
    ...(unsubstantiated ? { unsubstantiated: true } : {}),
    isPrimarySource: Boolean(isPrimarySource),
    docType,
  };
};

// Mirrors CitationInfoLabel.vue's colors — citation-dom.js injects raw CSS into the iframe and
// can't @use the SCSS tokens directly, so these are duplicated by hand.
export const CITATION_TAG_COLORS = {
  border: '#e8e7e5',
  unsubstantiatedBorder: '#1c1c1d',
  neutral2: '#6a6765',
};
